export enum ROOM_STATUS {
  "IN_PROGESS" = "in-progress",
  "COMPLETED" = "completed",
}

export enum VIDEO_CALL_COMPLETE_REASON {
  OK = "ok",
  MISSED = "missed",
  PERMISSIONS = "permissions",
  REJECTED = "rejected",
  CONNECTION = "connection",
}

export interface RoomParticipant {
  user_uuid: string;
}

export interface CreateVideoCallApiResponse {
  session_id: string;
  token: string;
  room_uuid: string;
  is_transcription_enabled: boolean;
  is_rating_required: boolean;
}

export interface SendVideoCallLogsApiQuery {
  room_uuid: string;
  status: string;
  payload: VideoCallPayloadApi;
}

export interface VideoCallRatingQuery {
  rate: number;
  notes?: string;
}

export interface VideoCallPayloadApi {
  app_version: string;
  platform: string;
  reason?: string;
  errors?: VideoCallError[];
}

export interface VideoCallError {
  reason: string;
  exception?: unknown;
  timestamp: number;
}

export interface VideoCallRoom {
  chat_id: string;
  room_uuid: string;
  session_id: string;
  token: string;
  status: ROOM_STATUS;
  is_transcription_enabled: boolean;
  is_rating_required: boolean;
}
